export const primaryFont = 'Monument Extended';
export const workSans = 'Work Sans';
export const apercu = 'Apercu';
export const apercuPro = 'Apercu Pro';
export const inter = 'Inter';
export const romanaBT = 'Romana BT';
